import styled, { keyframes } from 'styled-components'

import { colors } from '../../styles/colors'
import dimensions from '../../styles/dimensions'
import { ILabelProps, IIndicatorProps } from './RadioComponent.types'

export const Input = styled.input`
  display: none;
  height: 0;
  width: 0;
  opacity: 0;
  z-index: -1;
`

export const popIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.5) ;
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1) ;
  }
`

export const Label = styled.label<ILabelProps>`
  height: 0;
  position: relative;
  display: flex;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  margin: ${dimensions.componentHeight.large / 2}px 0
    ${dimensions.componentHeight.large / 2}px 15px;
  padding-left: 10px;
  color: ${props =>
    props.$borderColor ? props.$borderColor : colors.grayDark};
  align-items: center;
`

export const Indicator = styled.div<IIndicatorProps>`
  border: 1px solid;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  position: absolute;
  top: 5;
  left: -15px;

  &::after {
    content: '';
    position: absolute;
    display: none;
  }

  ${Input}:checked + &::after {
    display: block;
    border: solid ${props => (props.color ? props.color : colors.blue)};
    border-radius: 1em;
    background-color: ${props => (props.color ? props.color : colors.blue)};
    width: 4px;
    height: 4px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-name: ${popIn};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }

  ${Input}:disabled + & {
    pointer-events: none;
    opacity: 0.6;
    background: ${colors.gray};
  }
`
